type ProfileValidationResult = {
  isValid: boolean;
  missingFields: MissingField[];
};

export type MissingField =
  | "email"
  | "firstName"
  | "lastName"
  | "position"
  | "networkingProfile"
  | "networkingProfileCountry"
  | "networkingProfileCity"
  | "networkingProfileEmploymentType"
  | "workName"
  | "networkingProfileCompanyTypes"
  | "networkingProfileinterestCompanyTypes"
  | "networkingProfilelanguages"
  | "companyAssociation";

export const validateProfile = (response: any): ProfileValidationResult => {
  const missingFields: MissingField[] = [];

  if (!response.email) missingFields.push("email");
  if (!response.firstName) missingFields.push("firstName");
  if (!response.lastName) missingFields.push("lastName");
  if (!response.position) missingFields.push("position");

  if (!response.networkingProfile) {
    missingFields.push("networkingProfile");
  } else {
    if (!response.networkingProfile.country)
      missingFields.push("networkingProfileCountry");
    if (!response.networkingProfile.city)
      missingFields.push("networkingProfileCity");
    if (!response.networkingProfile.employmentType)
      missingFields.push("networkingProfileEmploymentType");

    if (response.networkingProfile.employmentType === 1) {
      if (!response.workName) missingFields.push("workName");
      if (!response.networkingProfile.companyTypes?.length) {
        missingFields.push("networkingProfileCompanyTypes");
      }
    }
  }

  if (!response.networkingProfile?.interestCompanyTypes?.length) {
    missingFields.push("networkingProfileinterestCompanyTypes");
  }
  if (!response.networkingProfile?.languages?.length) {
    missingFields.push("networkingProfilelanguages");
  }

  return {
    isValid: missingFields.length === 0,
    missingFields,
  };
};
